import styled from 'styled-components';

export const CalendarInterval = styled.div`
  display: flex;
  justify-content: space-around;
  p {
    cursor: pointer;
    color: #47b972;
    font-size: 13px;
    text-align: left;
  }
  p:hover {
    /*color: #6200ff; */
    color: #fff;
  }
`;
